import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function documentsSelectedReducer(state = initialState, action) {
  switch (action.type) {
    case types.DOCUMENTS_SELECTED_INIT:
      return { ...state, error: null, isLoading: true };

    case types.DOCUMENTS_SELECTED_SUCCESS:
      return { ...state, isLoading: false, items: action.data };

    case types.DOCUMENTS_SELECTED_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
